/**
 * Tracks storefront user actions that need stable public DOM hooks.
 *
 * Shopify owns each wallet button's closed shadow DOM. Keep this listener on
 * the document and identify the public wallet host element from composedPath();
 * this also survives the cart drawer being replaced after an AJAX cart update.
 * The product contact link uses a data attribute so tracking remains stable
 * when its translated label or merchant-configured URL changes.
 *
 * GTM runs inside the Shopify custom pixel sandbox, which has its own
 * dataLayer. Events are therefore published through the Customer Events API;
 * the custom pixel subscribes to 'custom_user_action' and pushes
 * { event: 'user_action', ux_action, ux_element, ux_text } to GTM.
 */
(() => {
  const bindingKey = '__cpapPaymentMethodTrackingBound';
  if (window[bindingKey]) return;
  window[bindingKey] = true;

  const cartDrawerWalletsSelector = '#cart-drawer .dynamic-cart-btns';
  const productContactLinkSelector = '.help-link-block [data-user-action="contact-us"]';
  const headerPhoneLinkSelector = '.phone-link[data-user-action="header-call-us"]';
  const paymentMethodByTagName = Object.freeze({
    'shop-pay-wallet-button': 'Shop Pay',
    'shopify-apple-pay-button': 'Apple Pay',
    'shopify-paypal-button': 'PayPal',
    'shopify-google-pay-button': 'Google Pay'
  });

  const publishUserAction = (payload) => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    try {
      publish('custom_user_action', payload);
    } catch (error) {
      // Tracking must never block the user's intended action.
    }
  };

  document.addEventListener('click', (event) => {
    const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const headerPhoneLink = eventPath.find((node) => (
      node instanceof Element && node.matches(headerPhoneLinkSelector)
    ));

    if (headerPhoneLink) {
      publishUserAction({
        ux_action: 'click',
        ux_element: 'button',
        ux_text: 'Call Us | Header'
      });
      return;
    }

    const productContactLink = eventPath.find((node) => (
      node instanceof Element && node.matches(productContactLinkSelector)
    ));

    if (productContactLink) {
      publishUserAction({
        ux_action: 'click',
        ux_element: 'button',
        ux_text: 'Contact Us'
      });
      return;
    }

    const walletButton = eventPath.find((node) => (
      node instanceof Element && paymentMethodByTagName[node.localName]
    ));

    if (!walletButton || !walletButton.closest(cartDrawerWalletsSelector)) return;

    publishUserAction({
      ux_action: 'click',
      ux_element: 'button',
      ux_text: paymentMethodByTagName[walletButton.localName]
    });
  }, true);
})();
